module.exports = __webpack_public_path__ + "static/media/IC_tutorial.8b2b4bee.svg";